import { Injectable, inject } from '@angular/core';
import { catchError, finalize, tap } from 'rxjs/operators';
import { of, BehaviorSubject, Observable, lastValueFrom } from 'rxjs';
import { CampaignsReceiptCodeAdminApiClient, IReceiptCodeQuery, ReceiptCode, ReceiptCodeQuery, ReceiptCodeResponse } from '../api/api-campaigns.service.generated';

@Injectable({
  providedIn: 'root'
})
export class ReceiptCodeDatasourceService {
  private client = inject(CampaignsReceiptCodeAdminApiClient);


  receiptCodes: ReceiptCode[] = [];
  filter: IReceiptCodeQuery;

  pageAvailable = new BehaviorSubject<ReceiptCode[]>([]);

  isLoading: boolean;
  isLoadingDisabled = false; // disabled ngx-datatable internal loader
  isError = false;
  isErrorRetry = false;
  isFirstRequest = true;
  hasMoreItems = true;
  error = '';
  pageLimit = 100;
  total: number;

  onSearch(f: IReceiptCodeQuery) {
    this.filter = f;
    this.receiptCodes = [];
    this.total = undefined;
    this.hasMoreItems = true;
    this.isFirstRequest = true;
    lastValueFrom(this.getNextPage());
  }

  getNextPage(): Observable<ReceiptCodeResponse> {
    const skip = this.receiptCodes.length;
    const limit = this.pageLimit;

    this.isLoading = true;
    this.isError = false;
    this.error = '';

    return this.client.queryReceiptCodes(<ReceiptCodeQuery>{
        ...this.filter,
        skip: skip,
        maxItems: limit
      })
      .pipe(
        catchError(err => {
          this.isError = true;
          this.isErrorRetry = true;
          this.error = JSON.stringify(err);
          return of(null);
        }),
        tap((chunk: ReceiptCodeResponse) => {
          if (!chunk || !chunk.receiptCodes)
            return;

          this.isErrorRetry = false;
          this.receiptCodes = [ ...this.receiptCodes, ...chunk.receiptCodes ];
          this.total = chunk.total;
          this.hasMoreItems = this.receiptCodes.length < this.total;
          this.pageAvailable.next(chunk.receiptCodes);
        }),
        finalize(() => {
          this.isLoading = false;
          this.isFirstRequest = false;
        })
      );
  }
}
